module.exports = __webpack_public_path__ + "static/media/the-game-afl-2025-mazda-prize.d3f10c8d.png";